import { TableSize, TdStyles } from './types';

export const tdth = (size: TableSize): TdStyles => ({
  padding: '0px',
  paddingTop: size === 'compact' ? 1 : 3,
  paddingBottom: size === 'compact' ? 1 : 3,
  verticalAlign: 'top',
  wordBreak: 'break-word',
});

export const defaultCellStyles = (
  size: TableSize
): Record<'base', TdStyles> => ({
  base: { paddingRight: size === 'compact' ? 2 : 3 },
});
